import {Model} from '@vuex-orm/core';
import {IPrivileges} from "@/interfaces/commons/IPrivileges";

// @ts-ignore
export default class Privileges extends Model implements IPrivileges {
    static entity = 'privileges';

    static fields () {
        return {
            privilegeId: this.number(1),
            canUploadExcel: this.boolean(false),
            canSeeUnitPlans: this.boolean(false),
            canCudPlanAndClose: this.boolean(false),
            canSeeComments: this.boolean(false),
            canEditPurposeAndAddOrRemoveOAs: this.boolean(false),
            canSeePurposeAndUnitObjectives: this.boolean(false),
            canEditCoverageAndActivitiesAndReprogramOAAndAdvanceAndComment: this.boolean(false),
            canSeeUnitCoverageAndActivities: this.boolean(false),
            canSeeAdvance: this.boolean(false),
            canSeeReportPlanFilters: this.boolean(false),
            canSeeReportPlanPurpose: this.boolean(false),
            canSeeReportPlanPlanification: this.boolean(false),
            canSeeReportPlanCronogram: this.boolean(false),
            canSeeReportAnual: this.boolean(false),
            canSeeReportCourse: this.boolean(false),
            canSeeReportInstitution: this.boolean(false),
            canFilterByInstitution: this.boolean(false),
            canFilterBySubject: this.boolean(false),
            canFilterByLevel: this.boolean(false),
            canFilterByUnit: this.boolean(false),
            canFilterByCourse: this.boolean(false),
            canFilterByStatus: this.boolean(false),
            canFilterByTeacher: this.boolean(false),
            canFilterByPercentage: this.boolean(false),
        };
    }
};
